import React from "react";

import Grid from "@mui/material/Grid";
import VuiBox from "@/Components/VuiBox";
import VuiTypography from "@/Components/VuiTypography";
import VuiButton from "@/Components/VuiButton";

import { ElectricalSwitch, ModelBrand } from "@/DatabaseControls/DataTypes";

import ElectricalSwitchImage from "./ElectricalSwitchImage";
import ElectricalSwitchInfo from "./ElectricalSwitchInfo";

import { useTranslation } from "react-i18next";

import _ from "lodash";

const ElectricalSwitchWindow = ({
  electricalSwitchState,
  setElectricalSwitchState,
  modelBrandList,
  onSave,
  onDelete,
}: {
  electricalSwitchState: ElectricalSwitch;
  setElectricalSwitchState: (electricalSwitch: ElectricalSwitch) => void;
  modelBrandList: ModelBrand[];
  onSave: () => void;
  onDelete: () => void;
}) => {
  const { t } = useTranslation();

  const isEdit = !!electricalSwitchState.id;

  const handleSave = async () => {
    onSave();
  };

  const handleDelete = async (i) => {
    onDelete();
  };

  return (
    <>
      {electricalSwitchState && (
        <Grid container justifyContent="center">
          <Grid item xs={12}>
            <VuiBox my={3}>
              <VuiBox mx={1} mt={1} mb={3}>
                <Grid container spacing={3} alignItems="center">
                  <Grid item xs={12} lg={6}>
                    <VuiTypography
                      variant="h4"
                      fontWeight="medium"
                      color="white"
                    >
                      {electricalSwitchState?.Name || "New Electrical Switch"}
                    </VuiTypography>
                    <VuiBox mt={1} mb={2}>
                      <VuiTypography variant="body2" color="text">
                        {t("common.pages.edit_description", {
                          title: _.toLower(
                            t("modules.electricalSwitches.title_singular"),
                          ),
                        })}
                      </VuiTypography>
                    </VuiBox>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <VuiBox display="flex" justifyContent="flex-end" gap={1}>
                      {isEdit && (
                        <VuiButton
                          variant="contained"
                          color="error"
                          onClick={handleDelete}
                        >
                          {t("common.buttons.delete")}
                        </VuiButton>
                      )}

                      <VuiButton
                        variant="contained"
                        color="info"
                        onClick={handleSave}
                      >
                        {t("common.buttons.save")}
                      </VuiButton>
                    </VuiBox>
                  </Grid>
                </Grid>
              </VuiBox>
              <Grid container spacing={2} justifyContent="space-between">
                <Grid item xs={12}>
                  <ElectricalSwitchInfo
                    electricalSwitch={electricalSwitchState}
                    setElectricalSwitchState={setElectricalSwitchState}
                    modelBrandList={modelBrandList}
                  />
                </Grid>

                <Grid item xs={12}>
                  <ElectricalSwitchImage
                    electricalSwitch={electricalSwitchState}
                    setElectricalSwitchState={setElectricalSwitchState}
                  />
                </Grid>
              </Grid>
            </VuiBox>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default ElectricalSwitchWindow;
